import React, {useRef, useState} from 'react';
import {POLICY_CONFIGS_IMPLEMENTED} from "../../../configs/policies";
import {getPolicyImagePath} from "../../../utils/policy/getPolicyImagePath";
import PolicyCardOverlay from "../../PolicyCardOverlay/PolicyCardOverlay";
import PageButton from "../../elements/PageButton/PageButton";
import {POLICY_DETAILED_RULES} from "./policyDetailedRules";
import {MENU_SOUND_MANAGER} from "../../../scenes/MenuSoundManager";

const PoliciesRules = () => {
  const [selectedPolicyId, setSelectedPolicyId] = useState(null);
  // Якоря блоков подробных правил: кнопка «Подробно» на плашке политики
  // прокручивает страницу правил к нужному блоку
  const policyRulesRefs = useRef({});

  // Тот же звук открытия карточки политики, что и в боковой панели списка
  // игроков (см. playCardSound в PlayerInfo). Звук дает обработчик, а не
  // PageButton (у него noSound) — иначе к нему добавился бы обычный клик
  const handleOpenPolicy = (policyId) => {
    MENU_SOUND_MANAGER.playCardOpen();
    setSelectedPolicyId(policyId);
  };

  const handleScrollToPolicyRules = (policyId) => {
    MENU_SOUND_MANAGER.playMenuButtonClick();
    policyRulesRefs.current[policyId]?.scrollIntoView({behavior: 'smooth', block: 'start'});
  };

  const coins = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/coins.png'}
    alt={'Монеты'}
    title={'Монеты'}
  />;

  const action = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/action.png'}
    alt={'Действие'}
    title={'Действие в фазе Строительства'}
  />;

  const selectedPolicy = POLICY_CONFIGS_IMPLEMENTED.find((policy) => policy.id === selectedPolicyId) || null;

  return (
    <div className="rules-page_content">
      <h2 className="rules-page_title text-construction">
        Политики
      </h2>

      <div className="rules-page_section">
        <p>
          В фазе Строительства игроки могут приобретать политики за монеты {coins} — они дают постоянные бонусы до
          конца игры (или до покупки другой политики).
        </p>
        <p>
          Покупка политики не тратит действие фазы Строительства.
        </p>
        <p>
          В одной фазе Строительства можно купить не более 1 политики.
        </p>
        <p>
          Новая политика начинает действовать сразу, если у игрока еще не было политики в момент приобретения.
          <br/>И только со следующего раунда, если у игрока уже была политика (старая остается действовать до конца
          текущего
          раунда).
        </p>
        <p>
          Цена политики на рынке зависит от ее позиции в списке предложений рынка: от 1 до 6 монет {coins}.
        </p>
        <p>
          За одно действие фазы Строительства {action} рынок политик можно <b>обновить</b>: все текущие
          карты рынка сбрасываются, и он заполняется новыми случайными политиками. Обновлять рынок можно
          не чаще одного раза за ход.
        </p>
      </div>

      <div className="rules-page_section">
        <div className="rules-page_policies-grid">
          {POLICY_CONFIGS_IMPLEMENTED.map((policy) => (
            <div
              key={policy.id}
              className="rules-page_policy-card"
              onClick={() => handleOpenPolicy(policy.id)}
            >
              <img
                className="rules-page_policy-card_image"
                src={getPolicyImagePath(policy.id)}
                alt={policy.name}
              />
              <div className="rules-page_policy-card_name text-construction">
                {policy.name}
              </div>
              <div className="rules-page_policy-card_description">
                {policy.description}
              </div>
              <div className="rules-page_policy-card_buttons">
                <PageButton
                  className="rules-page_card-details-button"
                  pageId="PoliciesRules"
                  buttonId={`policy_card_${policy.id}`}
                  noSound={true}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleOpenPolicy(policy.id);
                  }}
                >
                  Карточка
                </PageButton>
                <PageButton
                  className="rules-page_card-details-button"
                  pageId="PoliciesRules"
                  buttonId={`policy_details_${policy.id}`}
                  noSound={true}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleScrollToPolicyRules(policy.id);
                  }}
                >
                  Подробно
                </PageButton>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="rules-page_section">
        <h2>Подробные правила политик</h2>

        {POLICY_CONFIGS_IMPLEMENTED.map((policy) => {
          const PolicyRulesComponent = POLICY_DETAILED_RULES[policy.id];
          if (!PolicyRulesComponent) {
            return null;
          }

          return (
            <div
              key={policy.id}
              className="rules-page_policy-rules-block"
              ref={(element) => {
                policyRulesRefs.current[policy.id] = element;
              }}
            >
              <h3 className="rules-page_policy-rules-heading">
                <span className="rules-page_policy-rules-heading_icons">
                  <img
                    className="rules-page_policy-rules-heading_image"
                    src={getPolicyImagePath(policy.id)}
                    alt={policy.name}
                    title={policy.name}
                  />
                </span>
                <span className="text-construction">{policy.name}</span>
              </h3>

              {/* Ссылка-кнопка: открывает ту же карточку политики, что и
                    кнопка «Карточка» на плашке выше */}
              <button
                type="button"
                className="rules-page_policy-rules-heading_card-link text-controls"
                onClick={() => handleOpenPolicy(policy.id)}
              >
                Карточка
              </button>

              <PolicyRulesComponent/>
            </div>
          );
        })}
      </div>

      {selectedPolicy && (
        <PolicyCardOverlay
          selectedPolicy={selectedPolicy}
          onClose={() => setSelectedPolicyId(null)}
        />
      )}
    </div>
  );
};

export default PoliciesRules;
